import { render, staticRenderFns } from "./WalletBalance.vue?vue&type=template&id=5bb0d41e&"
import script from "./WalletBalance.vue?vue&type=script&lang=js&"
export * from "./WalletBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports